"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaretUp = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CaretUp = () => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "192", height: "192", fill: "currentcolor", viewBox: "0 0 256 256" }, { children: (0, jsx_runtime_1.jsx)("polyline", { points: "48 160 128 80 208 160", fill: "none", stroke: "currentcolor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "16" }) })));
};
exports.CaretUp = CaretUp;
